import React from "react";
import dynamic from "next/dynamic";
import { observer } from "mobx-react";

import CircleIcon from "common/CircleIcon/CircleIcon";
import Heart from "assets/icons/heart.svg";
import { useStore } from "store";
import { useUrl } from "helpers/hooks";

const Auth = dynamic(() => import("common/Auth/Auth"), { ssr: false });

const Favorites = () => {
  const { user, favorites } = useStore();
  const { getLinkProps } = useUrl();

  const handleClick = () =>
    user.withAuth({
      callback: () => {
        /* todo: refactor this */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).location = getLinkProps("/favorite/", "/favorite/", {
          withOrigin: true,
        }).as;
      },
    });

  return (
    <CircleIcon
      as="button"
      aria-label="Избранное"
      icon={<Heart />}
      counter={user.isAuth ? favorites.total : 0}
      onClick={handleClick}
    />
  );
};

export default observer(Favorites);
